import { useCallback } from 'react';

import { useCompleteTask } from '../useCompleteTask';
import type { TaskType } from '../useCompleteTask/constants';
import { useNextStepsExperiment } from '../useNextStepsExperiment';

export function useAutoCheckOffTask() {
	const {
		data: { isEnabled: isNextStepsEnabled },
	} = useNextStepsExperiment();
	const { mutate: completeTask } = useCompleteTask();

	const handleAutoCheckOffTask = useCallback(
		async (taskId: TaskType) => {
			if (isNextStepsEnabled) {
				await completeTask(taskId);
			}
		},
		[isNextStepsEnabled, completeTask],
	);

	return handleAutoCheckOffTask;
}
